import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const YoutubeDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 304.61" {...props}>
    <defs>
      <clipPath id="youtube1-1_svg__clip-path">
        <path fill="none" d="M1.98 151.62h138.37v127.72H1.98z" />
      </clipPath>
      <style>
        {
          '.youtube1-1_svg__cls-10{fill:none}.youtube1-1_svg__cls-5{fill:#f5f5f5}.youtube1-1_svg__cls-6{fill:#9e9e9e}.youtube1-1_svg__cls-7{fill:#424242}.youtube1-1_svg__cls-8{fill:#4286f5}.youtube1-1_svg__cls-10{stroke:#f5f5f5;stroke-miterlimit:10}'
        }
      </style>
    </defs>
    <g id="youtube1-1_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="youtube1-1_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v257.6a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V21.64A14.31 14.31 0 00124 7.33z"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path fill="#e62d27" d="M6.33 23.04H138.3v131.97H6.33z" />
        <g clipPath="url(#youtube1-1_svg__clip-path)">
          <path className="youtube1-1_svg__cls-5" d="M6.03 154.9h131.96v25.39H6.03z" />
          <path className="youtube1-1_svg__cls-6" d="M29.68 168.95h21.38v3.94H29.68zM29.69 162.94h34.36v4.21H29.69z" />
          <path className="youtube1-1_svg__cls-5" d="M13.39 191H64.2v3.94H13.39zM13.41 184.98h81.65v4.21H13.41z" />
          <circle className="youtube1-1_svg__cls-7" cx={19.94} cy={168.82} r={6.55} />
          <rect className="youtube1-1_svg__cls-8" x={99.78} y={163.83} width={28.09} height={9.87} rx={2.89} />
          <rect className="youtube1-1_svg__cls-8" x={99.78} y={261.64} width={28.09} height={9.87} rx={4.94} />
          <path
            className="youtube1-1_svg__cls-5"
            d="M29.68 245.96h21.38v3.94H29.68zM12.96 265.34h21.38v3.94H12.96zM29.69 239.95h34.36v4.21H29.69z"
          />
          <circle className="youtube1-1_svg__cls-7" cx={19.94} cy={245.82} r={6.55} />
          <path fill="#fe0000" d="M99.78 244.3h28.09v3.86H99.78z" />
          <circle className="youtube1-1_svg__cls-6" cx={18.49} cy={216.86} r={5.23} />
          <circle className="youtube1-1_svg__cls-6" cx={43.66} cy={216.86} r={5.23} />
          <circle className="youtube1-1_svg__cls-6" cx={68.82} cy={216.86} r={5.23} />
          <circle className="youtube1-1_svg__cls-6" cx={93.98} cy={216.86} r={5.23} />
          <circle className="youtube1-1_svg__cls-6" cx={119.15} cy={216.86} r={5.23} />
          <path className="youtube1-1_svg__cls-10" d="M6.03 233.07h131.36M6.03 257.29h131.36" />
          <path className="youtube1-1_svg__cls-6" d="M65.54 283.78h34.5v3.94h-34.5z" />
          <path className="youtube1-1_svg__cls-5" d="M75.8 292.18h14.91v3.94H75.8zM65.64 299.63h18.71v3.94H65.64z" />
          <path className="youtube1-1_svg__cls-6" d="M65.55 277.77h55.43v4.21H65.55z" />
          <path className="youtube1-1_svg__cls-7" d="M12.59 276.98h49.86v27.63H12.59z" />
          <path fill="#fcc642" d="M65.63 289.74h8.27v8.27h-8.27z" />
        </g>
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default YoutubeDevice11;
